import { render } from "./index.vue?vue&type=template&id=32e55a7d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=32e55a7d&lang=scss&scoped=true"

import exportComponent from "E:\\work\\高大\\pda\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e55a7d"]])

export default __exports__